import { CloseOutline } from 'antd-mobile-icons';
import { EnterOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import s from './style.module.scss';
import { getFileIcon } from '@/components/FileType';
import { Display } from '@/components/Display/Display';
import { fileTypeMap } from '@/utils/Page/constant';
import MyIcon from '@/components/MyIcon';
const MobileReference = ({ files, from = 'sender', setReferences }) => {
    const [fileIcon, setFileIcon] = useState('file');
    const [showFileName, setShowFileName] = useState('');
    const [extType, setExtType] = useState('');
    useEffect(() => {
        if (!files.length) {
            return;
        }
        let file = files[0];
        let fileIcon = getFileIcon({ suffix: file.type === fileTypeMap.link ? 'link' : file?.ext_type });
        setFileIcon(fileIcon);
        let ext_type = '';
        if (file.type !== fileTypeMap.link) {
            ext_type = `.${file?.ext_type}`;
        }
        setExtType(ext_type);
        setShowFileName(`${file.name}`);
    }, [files]);
    const onClose = () => {
        setReferences([]);
    };
    return (
        <>
            <div className={s['reference-box']} data-from={from}>
                <span className={s['reference-icon']}>
                    <MyIcon className={s['reference-icon']} type="icon-yinyong"></MyIcon>
                </span>
                <span className={s['file-icon']}>
                    <img src={fileIcon} alt="" />
                </span>
                <div className={s['reference-text-wrap']}>
                    <span className={s['reference-text']}>{showFileName}</span>
                    <span className={s['ext-type']}>{extType}</span>
                    <Display show={files.length > 1}>
                        <span className={s['reference-text-count']}>和其他{files.length - 1}个文件</span>
                    </Display>
                </div>
                <Display show={from === 'sender'}>
                    <span onClick={onClose} className={s['close-icon']}>
                        <CloseOutline />
                    </span>
                </Display>
            </div>
        </>
    );
};

export default MobileReference;
